module.exports = __webpack_public_path__ + "static/Sequence_CEP_1080-83f95cb584ece1ab55f82fdc2a0fb45a.mp4";